<template>
  <qtm-text-field
    v-bind="$attrs"
    ref="textfield"
    :append-inner-icon="focused ? visiblePasswordIcon : undefined"
    :hint="hint"
    :maxlength="MAX_PASSWORD_LENGTH"
    persistent-hint
    :type="passwordFieldType"
    @blur="focused = false"
    @click:append-inner="toggleShowPassword"
    @focus="focused = true"
  />
</template>

<script setup lang="ts">
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/constants'

export interface Props {
  withHint?: boolean
}

const props = defineProps<Props>()

const showPassword = ref(false)
const focused = ref(false)

const hint = computed(() => {
  return props.withHint && focused.value
    ? `At least ${MIN_PASSWORD_LENGTH} characters, including a letter or symbol`
    : undefined
})
const passwordFieldType = computed(() => (showPassword.value ? 'text' : 'password'))
const visiblePasswordIcon = computed(() => (showPassword.value ? 'mdi-eye-off' : 'mdi-eye'))

const toggleShowPassword = () => {
  showPassword.value = !showPassword.value
}

const textfield = ref<HTMLInputElement | null>(null)
const focus = () => {
  textfield.value?.focus()
}

defineExpose({ focus })
</script>
